var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5874_154169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7436 9.26113H19.7436L11.5858 9.26074C11.5858 9.26074 11.5858 9.26074 11.5858 9.26074C11.5017 9.26076 11.4336 9.32888 11.4336 9.41293V12.019C11.4336 12.103 11.5017 12.1712 11.5858 12.1712H16.1798H16.9083L16.6463 12.851C16.1627 14.106 15.3071 15.1794 14.2131 15.9304L15.6754 18.4618C18.406 16.6985 19.9988 13.8032 19.9988 10.5803C19.9988 10.1025 19.9641 9.76931 19.8946 9.38973L19.7436 9.26113ZM19.7436 9.26113C19.8151 9.26113 19.8806 9.31326 19.8946 9.38968L19.7436 9.26113Z",
    fill: "#374151",
    stroke: "#374151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 16.5871C8.25137 16.5871 6.28871 15.3587 5.23461 13.541L1.84375 15.4955C3.56934 18.4862 6.80191 20.5001 10.4996 20.5001C12.3135 20.5001 14.0251 20.0117 15.4996 19.1606V19.1559L13.5407 15.7649C12.6447 16.2846 11.6078 16.5871 10.4996 16.5871Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.1603V19.1557L13.5411 15.7646C12.6451 16.2843 11.6083 16.5868 10.5 16.5868V20.4998C12.3139 20.4998 14.0256 20.0114 15.5 19.1603Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41305 10.5002C4.41305 9.39207 4.71547 8.35531 5.23504 7.45934L1.84418 5.50488C0.988359 6.97469 0.5 8.68164 0.5 10.5002C0.5 12.3188 0.988359 14.0258 1.84418 15.4956L5.23504 13.5411C4.71547 12.6452 4.41305 11.6084 4.41305 10.5002Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 4.41305C11.9656 4.41305 13.3123 4.93398 14.3641 5.80051C14.6236 6.01426 15.0007 5.99883 15.2384 5.76113L17.0849 3.91465C17.3546 3.64496 17.3354 3.20352 17.0473 2.95359C15.285 1.42473 12.992 0.5 10.4996 0.5C6.80191 0.5 3.56934 2.51395 1.84375 5.50465L5.23461 7.4591C6.28871 5.64141 8.25137 4.41305 10.4996 4.41305Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3645 5.80051C14.624 6.01426 15.0012 5.99883 15.2389 5.76113L17.0853 3.91465C17.355 3.64496 17.3358 3.20352 17.0477 2.95359C15.2854 1.42469 12.9925 0.5 10.5 0.5V4.41305C11.966 4.41305 13.3127 4.93398 14.3645 5.80051Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5874_154169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.3ae83270b416ee0c7fef24db541542c9.svg";
export { ForwardRef as ReactComponent };